var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUser = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 16.5C14.6667 15.337 14.6667 14.7555 14.5232 14.2824C14.2 13.217 13.3663 12.3834 12.301 12.0602C11.8278 11.9167 11.2463 11.9167 10.0834 11.9167H5.91671C4.75374 11.9167 4.17225 11.9167 3.69909 12.0602C2.63375 12.3834 1.80007 13.217 1.47691 14.2824C1.33337 14.7555 1.33337 15.337 1.33337 16.5M11.75 5.25C11.75 7.32107 10.0711 9 8.00004 9C5.92897 9 4.25004 7.32107 4.25004 5.25C4.25004 3.17893 5.92897 1.5 8.00004 1.5C10.0711 1.5 11.75 3.17893 11.75 5.25Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/user.070054a9.svg";
export { ForwardRef as ReactComponent };